import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from './store'
// import Login from "./components/Auth/Login"
import Logout from "./components/Auth/Logout"
import ScoreStudy from "./components/score/Study"
import Menu from "./components/dashboard/menu"
// import Email from "./components/email/Email"
// import Profile from "./components/profile/Profile"
import store from './store'

//ทดสอบสร้างตัวแปรว่าลอคอินหรือยัง
// let state = false
//สร้างฟังก์ชันเช็ค route ก่อนเรียกใช้งาน (Route Auth Guard)
// function authGuard(to, from, next){

//   let isAuthenticated = false

//   if(localStorage.getItem('smk_access_token')){
//     isAuthenticated = true
//   }else{
//     isAuthenticated = false
//   }

//   if(isAuthenticated){
//     next() //อนุญาติให้เข้าสู่ route และโหลด component ที่ต้องการได้
//   }else{
//     next({name: 'login'})
//   }

// }

function authGuard(to, from, next) {
  let isAuthenticated = false
  if (store.getters['authentication/logedIn']) {
    isAuthenticated = true
  } else {
    isAuthenticated = false
  }
  if (isAuthenticated) {
    next() //อนุญาติให้เข้าสู่ route และโหลด component ที่ต้องการได้
    // router.push({
    //   name: 'Dashboard'
    // })
  } else {
    next({ name: 'login' })
  }
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // name: 'menu',
    component: Menu,
    beforeEnter: authGuard,
    meta: {
      title: 'Beranda'
    }
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
    beforeEnter: authGuard,
    meta: {
      title: 'Beranda'
    }
  },
  {
    path: '/pengumuman',
    name: 'announcement',
    component: require('./components/announcement/AnnouncementFeed.vue').default,
    beforeEnter: authGuard,
    meta: {
      title: 'Pengumuman'
    }
  },
  {
    path: '/pengumuman/:id',
    name: 'announcementDetail',
    component: require('./components/announcement/AnnouncementDetail.vue').default,
    beforeEnter: authGuard,
    meta: {
      title: 'Pengumuman'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: require('./components/Auth/Login.vue').default,
    meta: {
      title: 'LOGIN',
      description: 'login',
      requiresVisitor: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
  {
    path: '/score-study',
    name: 'score-study',
    component: ScoreStudy,
    meta: {
      title: 'Hasil kuliah'
    },
    // meta: {requiresAuth: true}
    beforeEnter: authGuard
  },
  {
    path: '/profile',
    name: 'profile',
    component: require('./components/profile/Profile.vue').default,
    meta: {
      title: 'Profil',
      // domains: 'student.kisda.online'
    },
    // meta: {requiresAuth: true}
    beforeEnter: authGuard
  },
  {
    path: '/profileEdit',
    name: 'profileEdit',
    component: require('./components/profile/BiodataForm.vue').default,
    meta: {
      title: 'Ubah profil'
    },
    beforeEnter: authGuard
  },
  // {
  //   path: '/email',
  //   name: 'email',
  //   component: Email,
  //   // meta: {requiresAuth: true} 
  //   beforeEnter: authGuard
  // },
  {
    path: '/leaning',
    name: 'learning',
    component: require('./components/learning/Learning.vue').default,
    meta: {
      title: 'Perkuliahan'
    },
    // meta: {requiresAuth: true}
    beforeEnter: authGuard
  },
  {
    path: '/lineNotify',
    name: 'lineNotify',
    component: require('./components/lineNotify/Index.vue').default,
    // meta: {requiresAuth: true}
    meta: {
      title: 'Line notify'
    },
    beforeEnter: authGuard
  },
  {
    path: '/studyResult',
    name: 'studyResult',
    component: require('./components/studyResult/Index.vue').default,
    // meta:{requireAuth: true}
    meta: {
      title: 'Hasil kuliah'
    },
    beforeEnter: authGuard
  },
  {
    path: '/studyResult/markah/:rs',
    name: 'studyResultMarkah',
    component: require('./components/studyResult/MarkahKomponen.vue').default,
    props: true,
    meta: {
      title: 'Markah Komponen'
    },
    beforeEnter: authGuard
  },
  {
    path: '/payment',
    name: 'payment',
    component: require('./components/payment/Index.vue').default,
    // meta: {requiresAuth: true}
    meta: {
      title: 'Bayaran'
    },
    beforeEnter: authGuard
  },
  {
    path: '/form',
    name: 'FormDownload',
    component: require('./components/form/FormDownload.vue').default,
    meta: {
      title: 'Muat Turun Borang'
    },
    beforeEnter: authGuard
  },
  {
    path: '/latihanIlmiah',
    name: 'latihanIlmiah',
    component: require('./components/latihanIlmiah/LatihanIlmiah.vue').default,
    meta: {
      title: 'Latihan Ilmiah'
    },
    beforeEnter: authGuard
  },
  {
    path: '/attendance',
    name: 'attendance',
    component: require('./components/attendance/Index.vue').default,
    meta: {
      title: 'Kehadiran'
    },
    beforeEnter: authGuard
  },
  {
    path: '/attendanceDetail/:sr_id',
    name: 'AttendanceDetail',
    component: require('./components/attendance/Detail.vue').default,
    meta: {
      title: 'Laporan kehadiran'
    },
    beforeEnter: authGuard
  },
  {
    path: '/tamhidiResult',
    name: 'TamhidiResult',
    component: require('./components/tamhidi/Index.vue').default,
    meta: {
      title: 'Hasil tamhidi / mustawa'
    },
    beforeEnter: authGuard
  },
  {
    path: '/attendanceSubject/:sr_id',
    name: 'AttendanceSubject',
    component: require('./components/attendance/Subject.vue').default,
    meta: {
      title: 'Kehadiran'
    },
    beforeEnter: authGuard
  },
  {
    path: '/tamhidiAttendanceSubject/:semester/:year',
    name: 'TamhidiAttendanceSubject',
    component: require('./components/attendance/TamhidiSubject.vue').default,
    meta: {
      title: 'Kehadiran tamhidi'
    },
    beforeEnter: authGuard
  },
  {
    path: '/tamhidiAttendanceDetail/:mustawa_group_id/:semester/:year',
    name: 'TamhidiAttendanceDetail',
    component: require('./components/attendance/TamhidiAttendanceDetail.vue').default,
    meta: {
      title: 'Detail Kehadiran Tamhidi'
    },
    beforeEnter: authGuard
  },
  // module permohonan
  {
    path: '/applications',
    name: 'Applications',
    component: require('./components/application/Index.vue').default,
    meta: {
      title: 'Permohonan ijazah'
    },
    beforeEnter: authGuard
  },
  {
    path: '/applications/certificate',
    name: 'application-certificate',
    component: require('./components/application/Certificate.vue').default,
    meta: {
      title: 'Mohon Ijazah'
    },
    beforeEnter: authGuard
  },
  {
    path: '/applications/certificate/status/:id',
    name: 'application-certificate-status',
    component: require('./components/application/CertificateStatus.vue').default,
    meta: {
      title: 'Status Permohonan Ijazah'
    },
    beforeEnter: authGuard
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['authentication/logedIn']) {
      router.push({
        name: 'login'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters['authentication/logedIn']) {
      router.push({
        name: 'Menu'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       if(!localStorage.getItem('smk_access_token')){
//         next({
//           name: 'login',
//         })
//       } else {
//         next()
//       }
//     }else if(to.matched.some(record => record.meta.requiresVisitor)) {
//       if(localStorage.getItem('smk_access_token')){
//         next({
//           name: 'menu',
//         })
//       }else{
//           next()
//       }
//     }else{
//       next()
//     }
//   })

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if(!localStorage.getItem('smk_access_token')){
//       next({
//         name: 'Login',
//       })
//     } else {
//       next()
//     }
//   }else if(to.matched.some(record => record.meta.requiresVisitor)) {
//     if(localStorage.getItem('smk_access_token')){
//       next({
//         name: 'menu',
//       })
//     }else{
//         next()
//     }
//   }else{
//     next()
//   }
// })

export default router